import IEntrepreneur from "@/module/main/dto/customer/IEntrepreneur";
import IAddress from "@/module/main/dto/customer/IAddress";

export default class Entrepreneur implements IEntrepreneur {
    constructor(
        public activeFrom?: string,
        public addresses?: IAddress[],
        public businessArea?: string,
        public businessId?: string,
        public name?: string
    ) {}
}
